<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT_APPOINTMENT|Lista protokołów' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <div class="protocol-navbar-wrapper">
            <div class="protocol-navbar">
                <div *ngFor="let appointment of data.appointments" class="protocol-navbar__item" (click)="scrollTo(appointment.internalIndex)">
                    {{ 'COMPLAINT_APPOINTMENT|Protokół do wizyty #{internalIndex}' | translate: { internalIndex: appointment.internalIndex } }}
                </div>
            </div>
        </div>
        <div class="protocol-list">
            <ng-container *ngFor="let appointment of data.appointments">
                <div class="protocol-title" [id]="'protocol-' + appointment.internalIndex">
                    <h1>{{ 'COMPLAINT_APPOINTMENT|Protokół do wizyty #{internalIndex} z dnia {date}' | translate: { internalIndex: appointment.internalIndex, date: (appointment.date | date: 'shortDate') } }}</h1>
                </div>
                <icc-complaint-appointment-protocol-edit
                    [complaintAppointment]="appointment"
                    [complaint]="data.complaint"
                    [editMode]="false"
                    [complaintAppointmentAttachments]="getAttachments(appointment.uuid)"
                    [clientView]="true"
                    [clientSigned]="true"
                >
                </icc-complaint-appointment-protocol-edit>
                <div class="signatures">
                    <div *ngIf="appointment.clientSignatureImage" class="signature-container">
                        <h3>{{ 'COMPLAINT_APPOINTMENT|Podpis klienta' | translate }}</h3>
                        <img *ngIf="appointment.clientSignatureImage" [src]="appointment.clientSignatureImage" class="signature-image" alt="Podpis klienta" />
                        <p *ngIf="!appointment.clientSignatureImage">{{ 'COMPLAINT_APPOINTMENT|Brak podpisu klienta' | translate }}</p>
                    </div>

                    <div *ngIf="appointment.servicemanSignatureImage" class="signature-container">
                        <h3>{{ 'COMPLAINT_APPOINTMENT|Podpis serwisanta' | translate }}</h3>
                        <img *ngIf="appointment.servicemanSignatureImage" [src]="appointment.servicemanSignatureImage" class="signature-image" alt="Podpis serwisanta" />
                        <p *ngIf="!appointment.servicemanSignatureImage">{{ 'COMPLAINT_APPOINTMENT|Brak podpisu serwisanta' | translate }}</p>
                    </div>
                </div>
                <mat-divider class="protocol-divider"></mat-divider>
            </ng-container>
        </div>
    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate }}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>